import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function FinalCtaSection() {
  return <Section hasOrb={true} className="py-32 text-center" data-id="element-55">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-56">
        <motion.h2 initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.01
      }} transition={{
        duration: 0.5
      }} className="font-archivo text-[clamp(64px,12vw,120px)] uppercase leading-[0.85] tracking-tighter mb-12" data-id="element-57">
          START <br data-id="element-58" />
          <span className="text-brand" data-id="element-59">MONDAY.</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.01
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="w-full max-w-md" data-id="element-60">
          <Button testId="final-cta" className="w-full py-5 text-xl mb-6" scrollTo="offer" data-id="element-61">
            GET THE BLUEPRINT · $17
          </Button>

          <p className="text-ink-dim text-sm" data-id="element-62">
            No course. No community. No upsells required. Just the blueprint.
            $17.
          </p>
        </motion.div>
      </div>
    </Section>;
}